// eslint-disable-next-line import/prefer-default-export
export const isProduction = process.env.NODE_ENV === 'production';



// WEBPACK FOOTER //
// ./src/lib/util/isProduction.js